// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Utils$ReactHooksTemplate = require("../../common/utils.res.js");
var EmailFilter$ReactHooksTemplate = require("./emailFilter.res.js");
var EmailSelected$ReactHooksTemplate = require("./emailSelected.res.js");

function EmailFilterForm(props) {
  var onChange = props.onChange;
  var filter = props.filter;
  var handleOnChange = function ($$event) {
    Curry._1(onChange, {
          TAG: "Email",
          _0: EmailFilter$ReactHooksTemplate.setSelected(Caml_option.some(EmailSelected$ReactHooksTemplate.make(Utils$ReactHooksTemplate.formTargetValue($$event))), filter)
        });
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("p", {
                      children: "Email",
                      className: "text-xs p-2"
                    }),
                JsxRuntime.jsx("input", {
                      className: "border border-gray-200 hover:border-gray-400 focus:border-teal-500 outline-none w-full py-10-px px-1 text-sm bg-transparent",
                      type: "email",
                      value: Belt_Option.getWithDefault(Belt_Option.getWithDefault(EmailFilter$ReactHooksTemplate.selected(filter), ""), ""),
                      onChange: handleOnChange
                    })
              ]
            });
}

var make = EmailFilterForm;

exports.make = make;
/* react/jsx-runtime Not a pure module */
